import React, { useState, useEffect } from 'react';
import { BotaoMenor } from '../../StyledComponent';
import Base from '../Base';
import Termos from '../TermoPDF';
import EntendiDownload from '../EntendiDownload';
import { ReactComponent as Alerta } from '../../../assets/novosicones/Termos/Alerta.svg';
import { handleAcceptAccessTerm } from '../../../services/termo';
import Atualizar from '../../AtualizarPerfil';
import { sair } from '../../../middlewares';
import { useHistory } from 'react-router-dom';
import './styles.scss';

const PoliticasPDF = ({
  termosDeAcesso,
  readOnly,
  setCloseModal,
  showAtualizarPerfilScreen,
}) => {
  const [lerTermos, setLerTermos] = useState(false);
  const [enableCheckBox, setEnableCheckBox] = useState(false);
  const [enableButton, setEnableButton] = useState(false);
  const [atualizarScreen, setAtualizarScreen] = useState(false);
  const history = useHistory();
  var styleReadOnly = '';

  useEffect(() => {
    if (!termosDeAcesso) sair();

    fetch(termosDeAcesso[1]?.UriTxt)
      .then((response) => response.text())
      .then((data) => {
        document.getElementById('textoTermo').innerHTML = data;
      });
    let termoTexto = document.getElementById('textoTermoOut');

    termoTexto.addEventListener('scroll', (e) => {
      if (e.target.scrollTop + 400 >= termoTexto.scrollHeight) {
        setEnableCheckBox(true);
      }
    });
  }, []);

  const aceitarTermoRedirecionarRota = () => {
    handleAcceptAccessTerm(termosDeAcesso[1]?.Id);
    if (showAtualizarPerfilScreen) {
      setAtualizarScreen(true);
    } else {
      history.push('/interna');
    }
  };

  if (readOnly) styleReadOnly = { display: 'none' };
  else styleReadOnly = { display: 'unset' };

  return (
    <>
      {atualizarScreen && <Atualizar />}
      {lerTermos && !atualizarScreen ? (
        <Termos termosDeAcesso={termosDeAcesso} />
      ) : (
        <Base
          etapa='2'
          nomeEtapa={'Políticas de privacidade'}
          readOnly={readOnly}
          confirmar={enableButton}
          setCloseModal={setCloseModal}
        >
          <div className='politicas'>
            <div className='politicas__divTexto' id='textoTermoOut'>
              <p className='politicas__divTexto__texto' id='textoTermo'></p>
            </div>
          </div>
          <div
            className='centralized-column divBtnAceites'
            style={styleReadOnly}
          >
            <EntendiDownload
              enableCheckBox={enableCheckBox}
              enableButton={enableButton}
              setEnableButton={setEnableButton}
              url={termosDeAcesso[1]?.UriPdf}
            />

            <div className='centralized-space-between divBtnAceites__entendiConcordo'>
              <div className='centralized'>
                <Alerta style={{ height: '100%', width: '25%' }} />
                <span
                  style={{
                    color: '#B61817',
                    fontSize: '12px',
                    marginLeft: '15px',
                    fontWeight: '900',
                  }}
                >
                  Faça a leitura completa dos Termos e condições para prosseguir
                  no site.
                </span>
              </div>
              <button
                className='divBtnAceites__entendiConcordo__voltarParaTermos'
                onClick={() => {
                  {
                    setLerTermos(true);
                  }
                }}
                id='btnLiConcordoTemosCondicoes'
              >
                VOLTAR
              </button>
              <BotaoMenor
                disabled={enableButton ? false : true}
                onClick={() => {
                  aceitarTermoRedirecionarRota();
                }}
                id='btnLiConcordoTemosCondicoes'
              >
                CONFIRMAR
              </BotaoMenor>
            </div>
          </div>
        </Base>
      )}
    </>
  );
};

export default PoliticasPDF;
